module.exports = __webpack_public_path__ + "img/weixiu.2d0b51d7.png";